import { IBookedOffer, ITrip } from "../../../Orchestrator/Types/Index"
import { ITransformedMealForLegs } from "../../../Orchestrator/Types/Interface/IAddOns"
export class AddOnsContext {

    public bookingId: string = ""
    public bookedOffers: IBookedOffer[] = []
    public bookedTrips: ITrip[] = []
    public listOfLagsAddons: ITransformedMealForLegs = {}
    public routeTo: string[] = []
    public isUpgrade: boolean = false

    constructor() { }
}